import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedTask } from '@hooks/mocks/task'
import { useFindProfile } from '@hooks/profile'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'
import { api } from '@services/apiClient'

export function useFindTask(id: number) {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchTask() {
    if (!isMockEnvironment) {
      const { data } = await api.get<IGenericTask>(
        `sites/${siteId}/tasks/${id}`,
      )

      return data
    }
    return mockedTask
  }

  return useQuery({ queryFn: fetchTask, queryKey: ['TASK', id] })
}
